var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTw = function SvgTw(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 43 32",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h48v32H0V0z",
    fill: "#DE2110"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24.106v16H0V0z",
    fill: "#08399C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.63 11.16l-2.957-.608.63 2.954-2.258-2.005-.93 2.874-.954-2.867L8.92 13.53l.608-2.958-2.954.63 2.005-2.258-2.873-.93L8.57 7.06 6.548 4.817l2.958.608-.63-2.954 2.258 2.007.93-2.873.954 2.866 2.243-2.023-.607 2.958 2.954-.63-2.005 2.258 2.873.93-2.866.954z",
    fill: "#FFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.904 10.933l-.933.496-.91.537-1.057-.036-1.057.013-.898-.56-.922-.516-.497-.932-.54-.908.036-1.055-.012-1.055.56-.895.52-.92.932-.496.91-.538 1.058.036 1.058-.012.898.56.922.516.497.93.538.91-.036 1.054.012 1.055-.56.895z",
    fill: "#005387"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.29 8.018c0 1.79-1.45 3.242-3.242 3.242S8.806 9.81 8.806 8.018s1.45-3.242 3.242-3.242 3.242 1.45 3.242 3.242z",
    fill: "#FFF"
  })));
};
export default SvgTw;